// React
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
// Actions
import SignAction from 'actions/SignAction';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';
import LayoutStore from 'stores/LayoutStore';
import AlertStore from 'stores/AlertStore';
// Routes
import routes from 'routes/routes.jsx';
// Component
import Sidebar from 'components/sidebar/Sidebar';
import Appbar from 'components/appbar/Appbar';
import Alert from 'components/commons/Alert/Alert';
// Material ui components
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import styles from 'components/page/MainLayout/MainLayout.style';
import CssBaseline from '@mui/material/CssBaseline';
// CSS
import 'assets/css/style.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Theme
import theme from 'assets/theme/theme.js';

class Main extends React.PureComponent {

    state = {
        alertOpen: AlertStore.isOpen(),
        currentLanguage: LoggedUserStore.getCurrentLanguage(),
        displayLayout: LoggedUserStore.isLogged(),
        mobile: LayoutStore.isMobile(),
        rights: LoggedUserStore.getCurrentRights(),
        sidebarOpen: false
    };

    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    getCurrentRouteProp() {
        const [, path] = window.location.pathname.split('/');
        for (let i = 0; i < Object.keys(routes).length; i += 1) {
            if (routes[i].path.split('/')[1] === path || routes[i].path === '*')
                return routes[i];
        }
        return null;
    }

    logout = () => {
        SignAction.logout();
    };

    handledisplayLayout() {
        const currentRoute = this.getCurrentRouteProp();
        if (currentRoute && currentRoute.displayLayout === true)
            return true;
        return false;
    }

    componentDidMount() {
        LoggedUserStore.addChangeListener(this.onLoggedUserStoreChange);
        LayoutStore.addChangeListener(this.onLayoutStoreChange);
        AlertStore.addChangeListener(this.onAlertStoreChange);
        this.mounted = true;
    }

    componentWillUnmount() {
        LoggedUserStore.removeChangeListener(this.onLoggedUserStoreChange);
        LayoutStore.removeChangeListener(this.onLayoutStoreChange);
        AlertStore.removeChangeListener(this.onAlertStoreChange);
        this.mounted = false;
    }

    onLoggedUserStoreChange = () => {
        if (!this.mounted) {
            return false;
        }

        if (LoggedUserStore.isLogged() === true) {
            this.setState({
                displayLayout: LoggedUserStore.isLogged(),
                currentLanguage: LoggedUserStore.getCurrentLanguage(),
                rights: LoggedUserStore.getCurrentRights(),
            });
        }
    };

    onLayoutStoreChange = () => {
        this.setState({
            mobile: LayoutStore.isMobile()
        });
    };

    onAlertStoreChange = () => {
        this.setState({
            alertOpen: AlertStore.isOpen()
        });
    };

    toogleSidebar = () => {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    };

    renderAlert = () => {
        const config = AlertStore.getAlertConfig();
        return (
            <Alert
                text={config.text}
                type={config.type}
                position={config.position}
                open={this.state.alertOpen} />
        );
    };

    renderAppBar = () => {
        if (!this.state.displayLayout || this.handledisplayLayout() === false) return null;
        return (
            <Appbar
                toogleSidebar={this.toogleSidebar}
                sidebarOpen={this.state.sidebarOpen} />
        );
    };

    renderSidebar = () => {
        if (!this.state.displayLayout || this.handledisplayLayout() === false) return null;
        return (
            <Sidebar
                routes={routes}
                handleDrawerClose={this.toogleSidebar}
                sidebarOpen={this.state.sidebarOpen} />
        );
    };

    render() {
        const { classes } = this.props;

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <div className={classes.root}>
                        {this.renderAppBar()}
                        {this.renderSidebar()}
                        <main className={classes.content}>
                            <Switch>
                                {routes.map((prop, key) => {
                                    if (!LoggedUserStore.isAuthorized(prop.rightName))
                                        return null;

                                    if (prop.redirect) {
                                        if (prop.path === window.location.pathname)
                                            return <Redirect isExact from={prop.path} to={prop.to} key={key} />;
                                        return null;
                                    }
                                    return <Route isExact path={prop.path} component={prop.component} key={key} />;
                                })}
                                <Redirect from={'/'} to={'/dashboard'} />
                            </Switch>
                        </main>
                    </div>
                    {this.renderAlert()}
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

export default withStyles(styles)(Main);
